import { useState } from "react";
import { post } from "../networking/RequestService";

function useGetLinkedInExtensionConfigs() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [configs, setConfigs] = useState(null);

    const getConfigs = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({ fn: "getLinkedInExtensionConfigs" });
            setConfigs(response.data);
            return { data: response.data };
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { configs, loading, error, getConfigs };
}

export default useGetLinkedInExtensionConfigs;
